import React from 'react';
import {Orders, Products} from 'api';
import {LoadingPage} from 'components/loading-page';
import {DateTime} from 'components/UI/DateTime';
import {toastr} from 'react-redux-toastr';
import {withRouter} from 'react-router-dom';
import {UploadImage} from 'components/UI/Image';
import {connect} from 'react-redux';
import {ShowIf} from 'components/utils';
import {getPrice} from 'lib/convert';

const ORDER_STATUSES = {
  AWAITING: 0,
  FORWARED: 1,
  CANCELED: 2,
  FINISHED: 3,
};

class ManageOrderDetailProduct extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      orderData: null,
      totalPrice: 0,
      isLoading: false,
      status: 0
    };
  }

  async componentDidMount() {
    if (this.props.params && this.props.myBusinesses && this.props.params.id) {
      let params = {
        id: this.props.params.id,
        filter: {
          include: [
            'business',
            'order',
            {orderDetails: 'product'}
          ]
        }
      };
      await this.setState({isLoading: true});
      let totalPrice = 0;
      let orderData = {};
      await Orders.actions.getOrderBusinessDetail.request(params).then(response => {
        if (!response || !response.data) {
          return false;
        }
        let products = [];
        const orderBusiness = response.data;
        if (orderBusiness && orderBusiness.order) {
          orderData = {
            ...orderData,
            name: orderBusiness.order.customerName,
            phone: orderBusiness.order.customerPhone
          };
        }
        if (orderBusiness.orderDetails) {
          products = orderBusiness.orderDetails.map(orderDetail => ({
            ...orderDetail.product,
            quantity: orderDetail.quantity,
            orderPrice: orderDetail.price,
          }));
          const sumPrice = (total, item) => total + parseFloat(item.price) * parseFloat(item.quantity);
          totalPrice = orderBusiness.orderDetails.reduce(sumPrice, totalPrice);
        }
        orderData = {
          ...orderData,
          products,
          business: orderBusiness.business,
          status: orderBusiness.status,
          createdAt: orderBusiness.createdAt,
          updatedAt: orderBusiness.updatedAt,
        }
      }).catch((error) => {
        this.setState({isLoading: false});
        this.props.history.push('/my-business/orders');
        toastr.error('Lỗi!', 'Không tìm thấy đơn hàng này.');
      });
      await this.setState({
        orderData,
        totalPrice,
        isLoading: false,
      });
    }
  }

  cancelOrder() {
    if (this.props.params.id && confirm('Bạn chắc chắn muốn hủy đơn hàng này?')) {
      this.setState({isLoading: true});
      Orders.actions.cancelOrder.request({id: this.props.params.id}).then(response => {
        toastr.success('Thành công!', 'Hủy đơn hàng thành công');
        this.props.history.push('/my-business/orders');
      })
    }
  }

  finishOrder() {
    if (this.props.params.id && confirm('Xác nhận hoàn thành đơn hàng?')) {
      this.setState({isLoading: true});
      Orders.actions.finishOrder.request({id: this.props.params.id}).then(response => {
        toastr.success('Thành công!', 'Hoàn thành đơn hàng thành công');
        this.props.history.push('/my-business/orders');
      })
    }
  }

  goback() {
    this.props.history.push('/my-business/orders')
  }

  render() {
    if (!this.state.orderData) {
      return null;
    }
    return (
      <div className="shopping-cart-container">
        <LoadingPage isShow={this.state.isLoading} />
        <div className='shopping-cart-content'>
          <div className='table-list-item-shopping'>
            <div className='table-list-item-header'>
              <p className='table-list-item-header-content'>Thông tin người đặt hàng</p>
            </div>
            <div className='table-list-item-body'>
              <div className="item-shopping">
                <p className='item-shopping-name'><strong>Họ tên</strong>: {this.state.orderData.name}</p>
              </div>
              <div className="item-shopping">
                <p className='item-shopping-name'><strong>Số điện thoại</strong>: {this.state.orderData.phone}</p>
              </div>
            </div>
          </div>
          <div className='shopping-order-container mb10'>
            <div className='content-justify mb5'>
              <p className='shopping-order-title'>Tổng tiền</p>
              <p className='shopping-order-content-red'>{getPrice(this.state.totalPrice)}</p>
            </div>
            <p className='shopping-order-content-desc'>(Đã bao gồm VAT)</p>
            <p>Trạng thái: &nbsp;
              <ShowIf condition={this.state.orderData.status === ORDER_STATUSES.FORWARED}>
                <span className="label-primary larger">Đang tiếp nhận</span>
              </ShowIf>
              <ShowIf condition={this.state.orderData.status === ORDER_STATUSES.CANCELED}>
                <span className="label-danger larger">Đã hủy</span>
              </ShowIf>
              <ShowIf condition={this.state.orderData.status === ORDER_STATUSES.FINISHED}>
                <span className="label-success larger">Đã hoàn thành</span>
              </ShowIf>
            </p>
            <div className="box-action">
              <ShowIf condition={this.state.orderData.status === ORDER_STATUSES.FORWARED}>
                <button className='btn btn-success' onClick={this.finishOrder.bind(this)}>Hoàn thành đơn hàng</button>
              </ShowIf>
              <ShowIf condition={this.state.orderData.status === ORDER_STATUSES.FORWARED}>
                <button className='btn btn-danger' onClick={this.cancelOrder.bind(this)}>Hủy đơn hàng</button>
              </ShowIf>
            </div>
          </div>
          <div className="fair-box-order table-responsive">
            <table className="table table-striped col-lg-6">
              <thead>
              <tr>
                <th className="cell-small text-center">#</th>
                <th className="cell-large text-center">Hình sản phẩm</th>
                <th className="cell-large text-center">Thông tin sản phẩm</th>
                <th className="cell-medium text-right">Đơn giá</th>
                <th className="cell-normal text-right">Số lượng</th>
                <th className="cell-medium text-right">Thành tiền</th>
              </tr>
              </thead>
              <tbody>
                { this.state.orderData.products && this.state.orderData.products.map((product, index) => (
                  <tr key={product.id}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center wrap-image-table">
                      <UploadImage type="PRODUCT" width="auto" height="auto" image={product.images[product.images.length -1]} />
                    </td>
                    <td className="text-center">
                      <span style={{fontWeight: 'bold'}}>{product.name}</span>
                    </td>
                    <td className="text-right">{getPrice(product.orderPrice)}</td>
                    <td className="text-center">{product.quantity}</td>
                    <td className="text-right">{getPrice((product.orderPrice * product.quantity))}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    myBusinesses: state.myBusinesses.mainBusiness
  };
};

export default withRouter(connect(mapStateToProps)(ManageOrderDetailProduct));



// WEBPACK FOOTER //
// ./components/my-business/sub-view/manage-order/ManageOrderDetailProduct.jsx